<template>
  <div class="tipo">
    <div class="centro">
      <h1><span>Consulta por Tipo de Legislação</span></h1>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cards" />
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelBuscaSimplificada
        :dados="tiposLegislacaoFormatados"
        :generateUrl="generateUrl"
        titulo="Tipos de Legislação"
        v-if="!carregando && !erro"
      />
    </div>
  </div>
</template>

<script>
import LegislacaoMunicipalApi from "@/services/LegislacaoMunicipalApi";
import TipoLegislacaoApi from "@/services/TipoLegislacaoApi";
import Loading from "@/components/Loading";
import ErroResultados from "@/components/ErroResultados";
import PainelBuscaSimplificada from "@/components/PainelBuscaSimplificada";
import BuscaSimplesCards from "@/components/BuscaSimplesCards.vue";

export default {
  name: "MensagensVetoPorEnteFederativoPorTipoLegislacao",
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      carregando: true,
      erro: false,
      tiposLegislacao: [],
      filtro: {
        tipo_legislacao: [],
        ano: null,
      },
      enteFederativoId: null,
    };
  },
  computed: {
    tiposLegislacaoFormatados() {
      return this.tiposLegislacao.map((tipo) => {
        return {
          ...tipo,
          quantidade: tipo.quantidade_total,
        };
      });
    },
    cards() {
      return [
        {
          rota: { name: "MensagensVetoPorEnteFederativoPorTipoLegislacao", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-tipo-legislacao2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Legislação",
          descricao: "Consulte as Mensagens de Veto<br /> por <strong>tipo de legislação</strong>",
        },
        {
          rota: { name: "MensagensVetoPorEnteFederativoPorTipoVeto", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-tipo-veto2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Veto",
          descricao: "Consulte as Mensagens de Veto<br /> por <strong>tipo</strong>",
        },
        {
          rota: { name: "MensagensVetoPorEnteFederativoPorAno", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-indice-cronologico2.png"),
          iconeClasse: "indice-icon",
          titulo: "Índice Cronológico",
          descricao: "Consulte as Mensagens de Veto<br /> por <strong>ano</strong>",
        },
      ];
    },
  },
  components: {
    PainelBuscaSimplificada,
    Loading,
    ErroResultados,
    BuscaSimplesCards,
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();
    this.tipoLegislacaoApi = new TipoLegislacaoApi();
    this.findEnteFederativoAndLoadTiposLegislacao();
  },
  methods: {
    findEnteFederativoAndLoadTiposLegislacao: async function () {
      try {
        const allEntesFederativos = await this.legislacaoApi.getEntesFederativos();
        const enteFederativo = allEntesFederativos.find(ente => ente.slug === this.slug);

        if (!enteFederativo) {
          this.erro = true;
          this.carregando = false;
          return;
        }
        this.enteFederativoId = enteFederativo.id;
        this.carregarTiposLegislacao();
      } catch (err) {
        console.log("findEnteFederativoAndLoadTiposLegislacao", err);
        this.erro = true;
        this.carregando = false;
      }
    },
    carregarTiposLegislacao: async function () {
      try {
        if (this.tipoLegislacaoApi.cancelTokens.getTiposLegislacao) {
          this.tipoLegislacaoApi.cancelTokens.getTiposLegislacao.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.tiposLegislacao = await this.tipoLegislacaoApi.getTiposLegislacao(this.enteFederativoId);
        this.carregando = false;
      } catch (err) {
        if (this.tipoLegislacaoApi.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl(ano, dados) {
      this.filtro.tipo_legislacao.push(dados.id);
      this.filtro.ano = ano;

      this.$router.push({
        name: "MensagensVetoPorEnteFederativo",
        params: { slug: this.slug },
        query: {
          ...this.filtro,
          pagina: 1,
          qtd_por_pagina: 10,
          busca_avancada: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h1 span{
   background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #0e489f;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;/* limita o fundo ao tamanho do texto */
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}
</style>